module.exports = __webpack_public_path__ + "img/processingAnimation.a8337b57.gif";